module.exports = __webpack_public_path__ + "img/1.eac68f3f.gif";